import React from 'react';
import glamorous from 'glamorous';

import { media, font } from '../../styles';
import { propTypes, defaultProps } from './types';

export const rules = {
  fontWeight: 300,
  fontSize: font.getFontSize(1),
  lineHeight: font.getLineHeight(1.25),

  [media('sm')]: {
    lineHeight: font.getLineHeight(1.375),
  },
};

const style = props => ({
  ...rules,
  textAlign: props.align,
  ...props.glamStyle,
});

const Ul = glamorous.ul(style);

class List extends React.PureComponent {
  static propTypes = propTypes;
  static defaultProps = defaultProps;

  render() {
    const {
      children,
      style,
      ...rest,
    } = this.props;

    return (
      <Ul {...rest} glamStyle={style}>
        {children}
      </Ul>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/typography/List.js